// Package Imports
// import { UserOutlined } from '@ant-design/icons';
import ModuleIdentifierConst from 'core/common/moduleIdentifier';

// Project Imports
import resourceName from 'core/common/resourceName';
import ResourceItem from 'interfaces/resource';

const usersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
    />
  </svg>
);
const VendorResource: ResourceItem = {
  name: resourceName.vendorDetails,
  identifier: ModuleIdentifierConst.VENDOR,
  list: `${resourceName.vendorDetails}`,
  create: `${resourceName.vendorDetails}/create`,
  edit: `${resourceName.vendorDetails}/edit/:id`,
  show: `${resourceName.vendorDetails}/show/:id`,
  options: {
    label: 'Vendor',
    icon: usersIcon,
  },
};

export default VendorResource;
